// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/base.css'
import './assets/main.css'
import './assets/js/fit.js'
import './assets/animate.css'
import './assets/custom_animate.css'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
Vue.use(ElementUI);
Vue.config.productionTip = false
import { WOW } from 'wowjs'
import animated from 'wowjs/css/libs/animate.css'
Vue.use(animated)
//创建全局实例
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 需要执行动画的元素的 class
  animateClass: 'animated', //animation.css 动画的 class
  offset: 0, // 距离可视区域多少开始执行动画
  mobile: true, // 是否在移动设备上执行动画
  live: true, // 异步加载的内容是否有效
})
import base from '@/assets/js/base'
Vue.prototype.$baseUrl = base.baseUrl
console.log(base.baseUrl)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js